const executeSetHelpIconCode = (helpIconSrc) => {
    // Function to set help icon in header bar responsively
    const helpIcon = document.querySelector(".help-icon");
    helpIcon.src = helpIconSrc
    helpIcon.alt = "Help Center";
    return helpIcon.src;
}

window.executeSetHelpIconCode = executeSetHelpIconCode;